import { $ } from '@/libs/jquery/index'

interface ISelectorNode {
  selector: string
}

$.validator.addMethod('dependsfrom', (value: string, element: HTMLElement, params: ISelectorNode): boolean => {
  const check = $(`[data-selector="${params.selector}"]`).val() !== ''
  const result = $(element).hasClass('required')
    ? check
    : value !== ''
      ? check
      : true

  return result
}, 'Поле заполнено некорректно')
